import type {
  EmergencyConfigurationOnAzure,
  UpdateEmergencyConfigRequest,
} from '@/../generated-client/models';
import { useEmergencyConfigFields, type EmergencyConfigFieldValues } from './useEmergencyConfigFields';

export function useEmergencyConfigEdit(config: EmergencyConfigurationOnAzure) {
  const initialValues: EmergencyConfigFieldValues = {
    specName: config.spec_name,
    impactDetection: config.impact_detection,
    fallDetection: config.fall_detection,
    arcFlashDetection: config.arc_flash_detection,
  };

  const fields = useEmergencyConfigFields(initialValues);

  const submitConfig = (shouldForceApply: boolean): UpdateEmergencyConfigRequest => ({
    org_code: config.org_code,
    config_id: config.id,
    spec_name: fields.specName,
    impact_detection: fields.impactDetection,
    fall_detection: fields.fallDetection,
    arc_flash_detection: fields.arcFlashDetection,
    should_force_apply_this_update: shouldForceApply,
  });

  return { ...fields, submitConfig };
}
